import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick", "src", "alt"]
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "arrow left" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "arrow right" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["onKeyup", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "imageContainer",
      key: item
    }, [
      _createElementVNode("h4", {
        class: "imgText",
        onClick: ($event: any) => (_ctx.imgPreview(item.id, item.data.img.url, index))
      }, _toDisplayString(item.data.alt[0].text), 9, _hoisted_1),
      _createElementVNode("img", {
        class: _normalizeClass(_ctx.size),
        onClick: ($event: any) => (_ctx.imgPreview(item.id, item.data.img.url, index)),
        src: item.data.img.url,
        alt: item.data.img.alt
      }, null, 10, _hoisted_2),
      _createElementVNode("div", {
        id: item.id,
        class: "imageModal"
      }, [
        _createElementVNode("p", {
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.key(_ctx.content)), ["arrow-left"])),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.lastImgPreview(_ctx.content)))
        }, _hoisted_5, 32),
        _createElementVNode("p", {
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.key(_ctx.content)), ["arrow-right"])),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextImgPreview(_ctx.content)))
        }, _hoisted_7, 32),
        _createElementVNode("img", {
          class: "imageModalItem",
          id: "imagePriview",
          src: _ctx.image,
          alt: item.data.img.alt
        }, null, 8, _hoisted_8),
        _createElementVNode("a", {
          onKeyup: _withKeys(($event: any) => (_ctx.closeImgPreview(item.id)), ["enter"]),
          onClick: ($event: any) => (_ctx.closeImgPreview(item.id)),
          class: "close"
        }, null, 40, _hoisted_9)
      ], 8, _hoisted_3)
    ]))
  }), 128))
}